import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/instrumentos/pregunta_autoevaluacion'

const getPreguntas = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const crearPregunta = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarPregunta = async ({ id, indicador }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: indicador, onSuccessMessage }
}

const actualizarPregunta = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getPreguntas,
  crearPregunta,
  eliminarPregunta,
  actualizarPregunta,
}